<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>User
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <b-form-group :label-cols="5" label="First Name" :state="stateForField('firstName')" :invalid-feedback="errorForField('firstName')">
            <b-form-input v-model="user.firstName"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Last Name" :state="stateForField('lastName')" :invalid-feedback="errorForField('lastName')">
            <b-form-input v-model="user.lastName"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="E-Mail" :state="stateForField('emailAddress')" :invalid-feedback="errorForField('emailAddress')">
            <b-form-input v-model="user.emailAddress"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="QuickSight ARN" :state="stateForField('quickSightArn')" :invalid-feedback="errorForField('quickSightArn')">
            <b-form-input v-model="user.quickSightArn"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Password" description="Leave blank to not change" :state="stateForField('password')" :invalid-feedback="errorForField('password')">
            <b-form-input v-model="user.password"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Roles">
            <b-form-checkbox-group stacked v-model="user.roleIds" :options="roleOptions"/>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveUser()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import _ from 'lodash'
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'EditUserModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editUser: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        user: _.clone(this.$props.editUser),
        errors: [],
        roles: [],
        isSaving: false,
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },

    watch: {
      editUser (newValue) {
        this.clearAllErrors()
        this.user = newValue
      }
    },

    computed: {
      roleOptions () {
        return this.roles.map((role) => {
          return { value: role.roleId, text: role.name }
        })
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      closeModal () {
        this.clearAllErrors()
        this.$emit('update:visible', false)
      },

      loadData () {
        api.get('/Dashboard/Roles').then(response => {
          this.roles = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load roles: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      saveUser () {
        if (!this.validate()) {
          return
        }

        if (this.isSaving === true) {
          return
        }

        this.isSaving = true
        let urlSuffix = ''
        if (this.user.userId) {
          urlSuffix = '/' + this.user.userId
        }
        api.post('Dashboard/Users' + urlSuffix, this.user).then(response => {

          this.isSaving = false
          this.$emit('updated', response)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
